import React from 'react';
import styled, { css } from 'styled-components';
import { withSettings } from '../components';

const Icon = ({ name, settings }) => {
  const images = settings.theme.assets.images;

  switch (name) {
    // Alcohol Policy //
    case 'HOST_PROVIDES':
      return <img src={images.icon_beer_and_wine} className="icon alcohol_policy" alt="Host Provides Alcohol" />;
    case 'ALCOHOL_FREE':
      return <img src={images.icon_alcohol_free} className="icon alcohol_policy" alt="Alcohol Free" />;
    case 'BYOB':
      return <img src={images.icon_byob} className="icon alcohol_policy" alt="BYOB" />;

    // Dietary Restrictions //
    case 'GLUTEN_FREE':
      return <img src={images.icon_gluten_free} className="icon dietary_restrictions" alt="Gluten Free" />;
    case 'KOSHER':
      return <img src={images.icon_kosher} className="icon dietary_restrictions" alt="Kosher" />;
    case 'VEGETARIAN':
      return <img src={images.icon_vegetarian} className="icon dietary_restrictions" alt="Vegetarian" />;
    case 'VEGAN':
      return <img src={images.icon_vegan} className="icon dietary_restrictions" alt="Vegan" />;
    case 'PESCATARIAN':
      return <img src={images.icon_pescatarian} className="icon dietary_restrictions" alt="Pescatarian" />;
    case 'KOSHER_STYLE':
      return <img src={images.icon_kosher_style} className="icon dietary_restrictions" alt="Kosher Style" />;
    case 'NUT_ALLERGY':
      return <img src={images.icon_nut_free} className="icon dietary_restrictions" alt="Nut Allergy" />;

    // Dress Code //
    case 'PJS':
      return <img src={images.icon_pjs} className="icon dress_code" alt="PJ's" />;
    case 'CASUAL':
      return <img src={images.icon_casual} className="icon dress_code" alt="Casual (Jeans OK)" />;
    case 'DRESSY':
      return <img src={images.icon_dressy} className="icon dress_code" alt="Dressy (No Jeans)" />;
    case 'BLACK_TIE':
      return <img src={images.icon_black_tie} className="icon dress_code" alt="Black Tie" />;
    case 'THEMED':
      return <img src={images.icon_themed} className="icon dress_code" alt="Themed" />;

    // What's For Dinner //
    case 'APPETIZERS':
      return <img src={images.icon_appetizers} className="icon dinner_menu" alt="Appetizers" />;
    case 'MAIN_COURSE':
      return <img src={images.icon_main} className="icon dinner_menu" alt="Main Course" />;
    case 'DESSERTS':
      return <img src={images.icon_dessert} className="icon dinner_menu" alt="Desserts" />;

    case 'calendar-success':
      return (
        <svg className="icon calendar_success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 59"><path d="M51.18,40.43l-5.6,8-3.95-3.24a1,1,0,1,0-1.26,1.54l4.78,3.93a1,1,0,0,0,.64.23h.13a1,1,0,0,0,.69-.42l6.21-8.93a1,1,0,0,0-.25-1.39A1,1,0,0,0,51.18,40.43Z"/><path d="M52,34.48V5a1,1,0,0,0-1-1H46V1a1,1,0,0,0-1-1H38a1,1,0,0,0-1,1V4H15V1a1,1,0,0,0-1-1H7A1,1,0,0,0,6,1V4H1A1,1,0,0,0,0,5V56a1,1,0,0,0,1,1H39.1A13,13,0,1,0,52,34.48ZM39,2h5V8H39V2ZM8,2h5V8H8V2ZM2,6H6V9a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V6H37V9a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V6h4v8H2ZM2,55V16H50V33.64c-.2-.07-.4-.12-.6-.17l-.55-.15-.51-.1-.74-.11-.41,0A11.71,11.71,0,0,0,46,33c-.34,0-.67,0-1,0V21H7V50H33.64l.09.26c.09.24.17.49.27.72s.12.26.18.39.23.51.36.76l.18.31c.15.26.3.52.47.77l.19.26c.18.25.36.5.55.74.07.09.15.17.22.25s.31.37.47.54ZM40.31,34.33l-.32.15c-.19.1-.37.21-.55.32l-.48.28-.46.32-.51.38-.39.32c-.18.15-.34.3-.51.46s-.24.21-.35.33-.35.37-.52.57L36,37.7V32h7v1.36l0,0A12.78,12.78,0,0,0,40.31,34.33ZM33.57,42.2a3.58,3.58,0,0,0-.09.35c-.08.29-.16.58-.22.88s-.08.46-.11.7-.06.37-.08.57A11.2,11.2,0,0,0,33,46c0,.36,0,.73,0,1.09,0,.07,0,.14,0,.2a3.7,3.7,0,0,0,.07.48h0c0,.08,0,.15,0,.23H27V41h7l0,.07C33.82,41.44,33.69,41.82,33.57,42.2ZM9,41h7v7H9Zm0-9h7v7H9Zm34-2H36V23h7Zm-9,0H27V23h7Zm0,9H27V32h7ZM18,32h7v7H18Zm7-2H18V23h7Zm-9,0H9V23h7Zm2,11h7v7H18ZM46,57a11,11,0,0,1-6.11-1.86,11.7,11.7,0,0,1-1-.73l-.31-.29c-.2-.18-.39-.36-.57-.55l-.34-.38c-.17-.19-.32-.38-.47-.58s-.2-.25-.29-.38a9.2,9.2,0,0,1-.61-1c0-.08-.08-.16-.12-.24-.15-.29-.28-.58-.4-.88-.06-.13-.1-.26-.15-.39s-.18-.53-.25-.8a1.21,1.21,0,0,1,0-.18,12.31,12.31,0,0,1-.26-1.32s0-.06,0-.09A10,10,0,0,1,35,46a10.55,10.55,0,0,1,.06-1.13s0-.06,0-.09c0-.34.09-.68.16-1l0-.09c.07-.33.15-.66.25-1l.05-.11c.1-.31.21-.62.34-.93s.26-.56.41-.84l.1-.17.13-.21c.17-.29.36-.58.55-.85a1.56,1.56,0,0,1,.16-.2c.18-.24.37-.47.56-.69l.21-.23c.2-.21.4-.41.62-.6l.22-.2c.25-.21.51-.41.77-.6l.12-.09a10.87,10.87,0,0,1,4.42-1.79h0A10.78,10.78,0,0,1,46,35a11.12,11.12,0,0,1,1.16.06l.18,0c.33,0,.65.09,1,.16l.11,0c.35.08.69.17,1,.28l.06,0c.35.12.69.25,1,.4A11,11,0,0,1,46,57Z"/></svg>
      );

    case 'copy-to-clipboard':
      return (
        <svg className="icon copy_to_clipboard" viewBox="0 0 14 16" version="1.1" width="14" height="16" aria-hidden="true">
          <path fillRule="evenodd" d="M2 13h4v1H2v-1zm5-6H2v1h5V7zm2 3V8l-3 3 3 3v-2h5v-2H9zM4.5 9H2v1h2.5V9zM2 12h2.5v-1H2v1zm9 1h1v2c-.02.28-.11.52-.3.7-.19.18-.42.28-.7.3H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h3c0-1.11.89-2 2-2 1.11 0 2 .89 2 2h3c.55 0 1 .45 1 1v5h-1V6H1v9h10v-2zM2 5h8c0-.55-.45-1-1-1H8c-.55 0-1-.45-1-1s-.45-1-1-1-1 .45-1 1-.45 1-1 1H3c-.55 0-1 .45-1 1z" />
        </svg>
      );

    case 'ot-emblem':
      return (
        <svg className="icon ot_emblem" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 25" width="80" height="45">
          <path d="M48.6,9.5C48.6,9.5,48.6,9.4,48.6,9.5L48.6,9.5l-3.2-3.2l0,0l-1.9-1.9l-3.1-3.1l0,0c0,0-0.1-0.1-0.1-0.1
            c-0.8-0.8-1.9-1.2-3-1.2c-1.1,0-2.2,0.4-3,1.2c0,0-0.1,0-0.1,0.1l0,0l-3.1,3.1l0,0l-3.1-3.1l0,0c0,0-0.1-0.1-0.1-0.1
            C27.2,0.4,26.1,0,25,0c-1.1,0-2.2,0.4-3,1.2c0,0-0.1,0-0.1,0.1l0,0l-3.1,3.1l0,0l0,0l-3.1-3.1l0,0c0,0-0.1-0.1-0.1-0.1
            c-0.8-0.8-1.9-1.2-3-1.2c-1.1,0-2.2,0.4-3,1.2c0,0-0.1,0-0.1,0.1l0,0L6.5,4.4l0,0l0,0L4.6,6.3L1.5,9.4l0,0c0,0-0.1,0.1-0.1,0.1
            c-0.8,0.8-1.2,1.9-1.2,3c0,1.1,0.4,2.2,1.2,3c0,0,0,0.1,0.1,0.1l0,0l3.1,3.1l1.9,1.9l0,0l0,0l3.1,3.1l0,0c0,0,0.1,0.1,0.1,0.1
            c0.8,0.8,1.9,1.2,3,1.2c1.1,0,2.2-0.4,3-1.2c0,0,0.1,0,0.1-0.1l0,0l3.1-3.1l0,0l0,0l3.1,3.1l0,0c0,0,0.1,0.1,0.1,0.1
            c0.8,0.8,1.9,1.2,3,1.2c1.1,0,2.2-0.4,3-1.2c0,0,0.1,0,0.1-0.1l0,0l3.1-3.1l0,0l3.1,3.1l0,0c0,0,0.1,0.1,0.1,0.1
            c0.8,0.8,1.9,1.2,3,1.2c1.1,0,2.2-0.4,3-1.2c0,0,0.1,0,0.1-0.1l0,0l3.1-3.1l1.9-1.9l0,0l3.1-3.1l0,0c0,0,0.1-0.1,0.1-0.1
            c0.8-0.8,1.2-1.9,1.2-3C49.8,11.4,49.4,10.3,48.6,9.5z M31.2,16.7L31.2,16.7L27,12.5l0,0l0,0l4.2-4.2l0,0l4.2,4.2l0,0l0,0
            L31.2,16.7z M18.8,16.7L18.8,16.7l-4.2-4.2l0,0l0,0l4.2-4.2l0,0l0,0l4.2,4.2l0,0l0,0L18.8,16.7L18.8,16.7z M36.2,3.2
            c0.3-0.3,0.7-0.5,1.1-0.5c0.4,0,0.9,0.2,1.2,0.5l0,0l3.1,3.1l0,0l-4.2,4.2l-4.2-4.2L36.2,3.2z M23.9,3.3C24.2,3,24.6,2.8,25,2.8
            c0.4,0,0.9,0.2,1.2,0.5l0,0l3.1,3.1L25,10.6l-4.2-4.2L23.9,3.3z M11.5,3.3c0.3-0.3,0.7-0.5,1.1-0.5c0.4,0,0.9,0.2,1.2,0.5l0,0
            l3.1,3.1l-4.2,4.2L8.4,6.3L11.5,3.3z M3.4,13.7C3.1,13.3,3,12.9,3,12.5c0-0.4,0.2-0.9,0.5-1.2l0,0l3.1-3.1l4.2,4.2l-4.2,4.2
            L3.4,13.7z M13.8,21.8c-0.3,0.3-0.7,0.5-1.1,0.5c-0.4,0-0.9-0.2-1.2-0.5l0,0l-3.1-3.1l4.2-4.2l4.2,4.2L13.8,21.8z M26.2,21.8
            c-0.3,0.3-0.7,0.5-1.1,0.5c-0.4,0-0.9-0.2-1.2-0.5l0,0l-3.1-3.1l4.2-4.2l4.2,4.2L26.2,21.8z M38.5,21.7c-0.3,0.3-0.7,0.5-1.1,0.5
            c-0.4,0-0.9-0.2-1.2-0.5l0,0l-3.1-3.1l4.2-4.2l4.2,4.2l0,0L38.5,21.7z M46.6,13.7l-3.1,3.1l0,0l-3.2-3.2l-1-1l4.2-4.2l0,0l3.1,3.1
            c0.3,0.3,0.5,0.7,0.5,1.1C47.1,12.9,46.9,13.4,46.6,13.7L46.6,13.7z"/>
        </svg>
      );

    default:
      return null;
  }
};

const IconWrapper = ({ className, border, ...props }) => {
  if (border) {
    return <div className={[className, 'icon_border'].join(' ')}><Icon {...props} /></div>;
  }

  return <Icon {...props} />;
};

const StyledIconWrapper = styled(IconWrapper)`
  width: 50px;
  height: 50px;
  border: 1px solid #fff;
  border-radius: 50%;
  display: inline-block;

  .icon {
    position: relative;
    top: 2px;
    width: 36px;

    ${props => props.color && css`
      path {
        fill: ${props.color};
      }
    `}
  }
`;

const IconWithSettings = withSettings(StyledIconWrapper);

export { IconWithSettings as Icon };
